import { useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { updateSchedule, updateRecurrence } from '../../../data/api';
import toast from '../../Toast';

export const PUBLISH_TYPES = {
  'Single': 'SINGLE',
  'Recurrence': 'RECURRENCE',
};

type PublishProps = {
  scheduleId: string;
  publishType: string;
  published: boolean;
  successCallback?: Function;
  [x: string]: any;
};

export default function Publish({ scheduleId, publishType, published, successCallback, ...rest }: PublishProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const submitHandler = async (event: any) => {
    event.preventDefault();
    let result = null;
    setLoading(true);

    if (publishType === PUBLISH_TYPES.Single) {
      result = await updateSchedule(scheduleId, {
        published: !!!published,
      });
    }

    if (publishType === PUBLISH_TYPES.Recurrence) {
      result = await updateRecurrence(scheduleId, {
        published: !!!published,
      });
    }

    if (result?.success) {
      successCallback && successCallback();
      toast.success(result.message);
    } else {
      toast.error(result?.message);
    }

    setLoading(false);
  };

  const getButtonText = () => {
    if (!!published) {
      return publishType === PUBLISH_TYPES.Single ? 'Unpublish' : 'Unpublish All';
    } else {
      return publishType === PUBLISH_TYPES.Single ? 'Publish' : 'Publish All';
    }
  };

  const disabled = loading || scheduleId === '';

  return (
    <div className="d-flex flex-column">
      <Button
        variant="warning"
        {...rest}
        type="button"
        className={`d-flex justify-content-center align-items-center ${rest.className || ''}`}
        onClick={submitHandler}
        disabled={disabled}
      >
        <span>{getButtonText()}</span>
        {loading && <Spinner animation="border" variant="light" size="sm" className="ms-2" />}
      </Button>
    </div>
  );
}

